import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const waitForAfterpay = () =>
    new Promise((resolve) => {
        if (window.Afterpay) {
            resolve()
            return
        }

        let script = document.querySelector('script[src*="afterpay"]')

        if (script) {
            script.addEventListener('load', resolve, {once: true})
            return
        }

        script = document.createElement('script')
        script.src = 'https://js.afterpay.com/afterpay-1.x.js'
        script.async = true
        script.setAttribute('data-analytics-enabled', '')

        script.addEventListener('load', resolve, {once: true})

        document.head.appendChild(script)
    })

const AfterpayWidget = ({price}) => {
    const currentPrice = price?.currentPrice
    const {locale} = useMultiSite()
    const {currency} = useCurrency()
    const paymentsConfiguration = useCustomPreference('paymentsConfiguration')
    const [scriptReady, setScriptReady] = useState(false)

    useEffect(() => {
        if (!currentPrice) return
        waitForAfterpay().then(() => setScriptReady(true))
    }, [currentPrice])

    if (paymentsConfiguration?.afterpay?.widgetEnabled !== 'true') return

    return currentPrice && scriptReady ? (
        <Box
            as={'afterpay-placement'}
            data-locale={locale.id}
            data-currency={currency}
            data-amount={currentPrice.toFixed(2)}
            data-testid="afterpay-placement"
        />
    ) : null
}

AfterpayWidget.propTypes = {
    price: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
}

export default AfterpayWidget
